var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"morda-lenta-link",attrs:{"to":{ name: 'profile', params: {id: _vm.card.user.id}}}},[_c('div',{staticClass:"morda-lenta-front card-face"},[_c('div',{staticClass:"morda-lenta-avatar",class:{
                'no-avatar': !_vm.card.user.avatar
            },style:({
                'background-image':
                _vm.card.user.avatar ?
                'url(' + _vm.card.user.avatar + ')' :
                ''
            })}),_vm._v(" "),_c('CardFace',{attrs:{"suit":_vm.card.suit,"rank":_vm.ranks[_vm.card.rank] || _vm.card.rank}})],1),_vm._v(" "),_c('div',{staticClass:"morda-lenta-back card-shirt"},[_c('span',{attrs:{"lang":"ru"}},[_vm._v(_vm._s(_vm.card.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }